import * as React from "react";
import { Grid, Group } from "@mantine/core";
import UpcomingAppointments from "../home/UpcomingAppointments";
import UpcomingShifts from "../home/UpcomingShifts";
import { IProfileTabProps } from "./ProfileTabType";

export interface IProfileDashboardProps extends IProfileTabProps {}

export const ProfileDashboard: React.FunctionComponent<
  IProfileDashboardProps
> = (props) => {
  React.useEffect(() => {
    document.title = `Stadium Supervisor - ${
      props.person.preferredName || props.person.firstName
    } profile`;
  }, []);

  return (
    <Grid>
      <Grid.Col span={{ base: 12, sm: 6 }}>
        <UpcomingShifts />
      </Grid.Col>
      <Grid.Col span={{ base: 12, sm: 6 }}>
        <UpcomingAppointments />
      </Grid.Col>
    </Grid>
  );
};
